import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {SimilarTitleBookJacket} from 'react/views/bookJacket/BookJacket';
import { Card } from 'react/card/Card';
import CardTitle from 'react/card/CardTitle';
import CardContent from 'react/card/CardContent';
import ReadALikeFooter from 'react/card/ReadALikeFooter';
import * as utility from "../../../lib/PlaceholderUtility";
import SimilarTitlesEventTypes from 'data/types/SimilarTitlesEventTypes';
import TrackedLink from 'react/views/generic/TrackedLink';
import './similarTitlesView.less';

class SimilarTitlesView extends Component {
    renderBookJackets() {
        const bookJacketList = this.props.cardModel.map((jacket) => {
            return (
				<div className="similar-titles-jacket clickable" key={jacket.uniqueId} onClick={() => { this.props.onItemClick(jacket.uniqueId) }}>
					<TrackedLink featureType={SimilarTitlesEventTypes.SIMILARTITLE_GRIDCOVER_CLICKED} destId={jacket.uniqueId}>
						<SimilarTitleBookJacket image={jacket.bookJacket} title={jacket.title} />
					</TrackedLink>
				</div>
            );
        });

        return utility.addPlaceholderElements(bookJacketList, "similar-titles-jacket placeholder");
    }

    render() {
        return (
			<Card>
				<CardTitle title="Similar Titles" />
				<CardContent>
					{this.renderBookJackets()}
				</CardContent>
				<ReadALikeFooter onNext={this.props.onNext} onPrevious={this.props.onPrevious} />
			</Card>
        );
    }
}

SimilarTitlesView.propTypes = {
	cardModel: PropTypes.array,
	onNext: PropTypes.func,
	onPrevious: PropTypes.func
};

export default SimilarTitlesView;



// WEBPACK FOOTER //
// ./src/react/views/similarTitles/SimilarTitlesView.jsx